<div class="vehicle-tile-header">
    <div class="vehicle-tile-name">
      <div class="vehicle-tile-img">
        <img id="vehicle-image" alt="electric vehicle" appVehicleImageFallback [src]="vehicleService.getSelectedCarIcon()"
          [ngClass]="{'multiline': selectedCarMultilineString != '' }" />
      </div>
      <div class="vehicle-tile-details">
        <div class="vehicle-tile-text">
          <h2> {{ selectedCarNameString }} </h2>
          <h2 class="vehicle-tile-text-type"> {{ selectedCarMultilineString }} </h2>
        </div>
      </div>
    </div>
  </div>
